import { removeBaseUrl } from '@utils/url';
import Link from 'next/link';

type Props = { tags: string[] };

function ArticleTags(props: Props) {
  const { tags } = props;
  return (
    <div className='tags wrapper'>
      <span className='article-information__heading tags__heading'>Tags:</span>
      <span className='tags__listing'>
        {tags.map(tag => (
          <Link
            key={tags.indexOf(tag)}
            href={removeBaseUrl(`/artikel/tag/${encodeURIComponent(tag).toLowerCase()}`)}
            className='tag'>
            {tag}
          </Link>
        ))}
      </span>
    </div>
  );
}
export default ArticleTags;
